import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { checkToken, logoutUser } from "../api/auth";

export default function PrivateRoute({ children, roles }) {
  const [isValid, setIsValid] = useState(null);
  const currentRole = localStorage.getItem("role");

  useEffect(() => {
    const validateToken = async () => {
      try {
        if (!currentRole || !roles.includes(currentRole)) {
          setIsValid(false);
          return;
        }

        const valid = await checkToken(currentRole);
        setIsValid(valid);
      } catch (error) {
        console.error("Token check failed:", error);
        setIsValid(false);
      }
    };

    validateToken();
  }, [currentRole, roles]);

  if (isValid === null) return null;

  if (!isValid) {
    logoutUser(currentRole);
    return <Navigate to="/login" replace />;
  }

  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
};
